设备<template>
	<div class="menu">
		<ul>
			<li @click="allpitch()" :class="this.alls?'pitch':''"><div><img :src="imgnew.all" alt=""></div><span>全部设备</span></li>
			<li @click="pitchfun('video')" :class="this.phase.video?'pitch':''"><div><img :src="imgnew.video" ></div><span>视频监控设备</span></li>
			<li @click="pitchfun('door')" :class="this.phase.door?'pitch':''"><div><img :src="imgnew.door" ></div><span>门禁系统设备</span></li>
			<li @click="pitchfun('radio')" :class="this.phase.radio?'pitch':''"><div><img :src="imgnew.radio" ></div><span>广播系统设备</span></li>
			<li @click="pitchfun('news')" :class="this.phase.news?'pitch':''"><div><img :src="imgnew.news" ></div><span>信息发布设备</span></li>
		</ul>
	</div>
</template>

<script>
	export default {
	  name: "devpop",
	  data() {
	  	return{
			phase:{video:false,door:false,radio:false,news:false},
			imgs:{
				all:require('../../assets/img/allbg.png'),
				video:require('../../assets/img/videobg.png'),
				door:require('../../assets/img/doorbg.png'),
				radio:require('../../assets/img/gbbg.png'),
				news:require('../../assets/img/xxbg.png'),
				all1:require('../../assets/img/allbg1.png'),
				video1:require('../../assets/img/videobg1.png'),
				door1:require('../../assets/img/doorbg1.png'),
				radio1:require('../../assets/img/gbbg1.png'),
				news1:require('../../assets/img/xxbg1.png'),
			},
			imgnew:{
				all:require('../../assets/img/allbg.png'),
				video:require('../../assets/img/videobg.png'),
				door:require('../../assets/img/doorbg.png'),
				radio:require('../../assets/img/gbbg.png'),
				news:require('../../assets/img/xxbg.png'),
			},
			alls:false
		}
	  },
	  components: {
		  
	  },
	  methods: {
		//按钮点击
		pitchfun(str){
			this.phase[str]=!this.phase[str];
			document.getElementById('iframe').contentWindow.coverage(str,this.phase[str])
			if(this.imgnew[str]==this.imgs[str]){
				this.imgnew[str]=this.imgs[`${str}1`]
			}else{
				this.imgnew[str]=this.imgs[str]
			}
			for(let key  in this.phase){
				if(!this.phase[key]){
					this.alls=false
					this.imgnew['all']=this.imgs['all']
					return
				}
			 }
			 this.alls=true
			 this.imgnew['all']=this.imgs['all1']
		},
		//全选
		allpitch(){
			this.alls=!this.alls
			document.getElementById('iframe').contentWindow.coverage('all',this.alls)
			if(this.alls){
				this.imgnew['all']=this.imgs['all1']
			}else{
				this.imgnew['all']=this.imgs['all']
			}
			
			 for(let key  in this.phase){
			     this.phase[key]=this.alls
				 if(this.alls){
					 this.imgnew[key]=this.imgs[`${key}1`]
				 }else{
					 this.imgnew[key]=this.imgs[key]
				 }
			  }
		}
	  },
	  mounted() {
	     
	  }
	};
</script>

<style scoped="scoped">
	.menu{
		bottom: 6.9%;
		width: 48.3%;
		/* height: 4.6%; */
		left: 50%;
		transform: translateX(-50%);
		position: absolute;
		background-color: rgba(56, 91, 113,.5);
		border-radius: 4.6vh;
		box-sizing: border-box;
		padding: 2px 0;
		z-index: 3;
	}
	.menu>ul{
		width: 100%;
		height: 100%;
		display: flex;
		box-sizing: border-box;
		padding: 0 7.5%;
		align-items: center;
		justify-content: space-between;
	}
	.menu>ul>li{
		height: 100%;
		font-size: .8vw;
		font-family: "SourceHanSansCN";
		text-align: center;
		color: #FFFFFF;
		display: flex;
		align-items: center;
		cursor: pointer;
	}
	.menu>ul>li>span{
		    word-break:keep-all;       /* 不换行 */
		    white-space:nowrap;       /* 不换行 */
	}
	.menu>ul>li>div{
		margin-right: 5%;
	}
	.menu>ul>li>div>img{
		width: 2vw;
		height: 2vw;
		display: block;
	}
	.menu>ul>li.pitch{
		color: rgb(252, 159, 87);
		/* border: 1px solid rgb(206, 124, 46);
		background: rgba(206, 124, 46,.1); */
	}

</style>
